import BaseComponentController from '../../../../components/base-component.controller';

class ForeignInterferenceController extends BaseComponentController {
    constructor(_, componentRegistryService, $q, constants) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors: []
        };
        this.constants = constants;
    }

    init() {
        this.vm = {
            errors: []
        };
        if (this._.isEmpty(this.model)) {
            this.model = {
                question1: {
                    questionBool: null,
                    questionResponses: [
                        {
                            countryName: "",
                            organisationName: "",
                            associationSummary: "",
                            foreignAssociationType: this.constants.ForeignInterference.questions.question1.foreignAssociationType
                        }
                    ],
                },
                question2a: {
                    questionBool: null
                },
                question2b: {
                    questionBool: null,
                    questionResponses: [
                        {
                            countryName: "",
                            organisationName: "",
                            associationSummary: "",
                            foreignAssociationType: this.constants.ForeignInterference.questions.question2b.foreignAssociationType
                        }
                    ],
                },
                question2c: {
                    questionBool: null,
                    questionResponses: [
                        {
                            countryName: "",
                            organisationName: "",
                            associationSummary: "",
                            foreignAssociationType: this.constants.ForeignInterference.questions.question2c.foreignAssociationType
                        }
                    ],
                },
                question3: {
                    questionBool: null,
                    questionResponses: [
                        {
                            countryName: "",
                            organisationName: "",
                            associationSummary: "",
                            foreignAssociationType: this.constants.ForeignInterference.questions.question3.foreignAssociationType
                        }
                    ],
                },
                question4: {
                    questionBool: null,
                    questionResponses: [
                        {
                            countryName: "",
                            organisationName: "",
                            associationSummary: "",
                            foreignAssociationType: this.constants.ForeignInterference.questions.question4.foreignAssociationType
                        }
                    ],
                }
            };
        }
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    radioItemSelected() {
        this.vm = {
            errors: []
        };
    }
}

ForeignInterferenceController.$inject = ['_', 'componentRegistryService', '$q', 'constants'];

let foreignInterferenceComponent = {
    controller: ForeignInterferenceController,
    bindings: {
        readonly: '<',
        modelName: '@'
    },
    templateUrl: `app/disclose/conflictOfInterest/components/foreign-interference/foreign-interference.html`
};

export default foreignInterferenceComponent;


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/foreign-interference/foreign-interference.component.js